import request from '@/utils/request';
import { getDeviceInfo } from '@/utils/device-info';
//课程反馈与评价`
export function commentSaveApi(data) {
    return request({
        url: `/system/study/center/student/comment/save`,
        method: 'post',
        data
    })
}

//腾讯鉴权点播
export function getPlayTokenApi(fileId) {
    return request({
        url: `/system/study/center/chapter/getPlayToken/${fileId}`,
        method: 'get'
    })
}

//评价信息
export function getCommentByRequestApi(data) {
    return request({
        url: `/system/study/center/student/comment/getCommentByRequest`,
        method: 'post',
        data
    })
}
function getOS() {
  const ua = navigator.userAgent;
  let os = "Unknown";

  if (/Windows NT 10/.test(ua)) os = "Windows 10/11";
  else if (/Windows NT 6.3/.test(ua)) os = "Windows 8.1";
  else if (/Windows NT 6.2/.test(ua)) os = "Windows 8";
  else if (/Windows NT 6.1/.test(ua)) os = "Windows 7";
  else if (/Mac OS X (\d+[._]\d+)/.test(ua)) os = "macOS " + RegExp.$1.replace(/_/g, ".");
  else if (/Android (\d+(\.\d+)?)/.test(ua)) os = "Android " + RegExp.$1;
  else if (/iPhone OS (\d+_\d+)/.test(ua)) os = "iOS " + RegExp.$1.replace(/_/g, ".");
  else if (/Linux/.test(ua)) os = "Linux";

  return os;
}
//保存观看记录
export function saveVideoLearningApi(data) {
    return request({
        url: `/system/study/center/chapter/saveVideoLearning`,
        method: 'post',
        data:{
            ...data,
            isDownload:0,
            osVersion:getOS(),
        }
    })
}

//笔记保存
export function noteSaveApi(data) {
    return request({
        url: `/system/study/center/student/note/save`,
        method: 'post',
        data
    })
}

//笔记列表
export function noteListApi(data) {
    return request({
        url: `/system/study/center/student/note/getList`,
        method: 'post',
        data
    })
}